import {
  Component,
  HostBinding,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { NGXLogger } from "ngx-logger";
import { ConfirmationService, MenuItem, Message, MessageService, PrimeIcons } from "primeng/api";
import { environment } from '../../../../environments/environment';
import { debounceTime, distinctUntilChanged, of, Subject, switchMap, Observable } from "rxjs";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { SegnalazioniService } from "src/app/services/segnalazioni.service";
import { UtentiService } from "src/app/services/utenti.service";
import { Segnalazione } from "src/app/models/segnalazione.model";
import { UserService } from "src/app/services/user.service";
import { AreeCompetenzaService } from "src/app/services/areeCompetenza.service";
import { TipiInterventoService } from "src/app/services/tipiIntervento.service";
import { TipiSegnalazioneService } from "src/app/services/tipiSegnalazione.service";

import { Evento } from "src/app/models/evento.model";
import { EventiService } from "src/app/services/eventi.service";
import { CategoriaEvento } from "src/app/models/categoria.evento.model";
import { CategorieEventiService } from "src/app/services/categorieEventi.service";
import { Utente } from "src/app/models/utente.model";
import { TipoIntervento } from "src/app/models/tipoIntervento.model";
import { Intervento } from "src/app/models/intervento.model";
import { InterventiService } from "src/app/services/interventi.service";
import { AngularFirestore } from "@angular/fire/compat/firestore";
import { Evento_Firestore } from "src/app/models/firestore/eventoFirestore.model";
import {onSnapshot} from "firebase/firestore";
import {AreaCompetenza} from "../../../models/areaCompetenza.model";

@Component({
  selector: "modifica-evento",
  templateUrl: './modifica-evento.component.html',
  styleUrls: ['../agenda.component.css']
})
export class ModificaEventoComponent implements OnInit, OnDestroy {

  protected _onDestroy = new Subject<void>();

  protected modificaEventoForm: FormGroup;
  protected ref: DynamicDialogRef;

  protected isSegnalatore:Boolean = false;

  protected idEvento:string;
  protected idTecnico:string;
  protected selectedEvento:Evento;
  protected segnalazione:Segnalazione;
  protected intervento:Intervento;

  protected categorie:CategoriaEvento[]=[];
  protected isEventoForIntervento:boolean= false;
  protected isLoadingSegnalazioni:boolean= false;
  protected isLoadingTecnici:boolean= false;
  protected isLoadingTipiIntervento:boolean= false;
  protected isLoadingOperatori: boolean = false;

  protected mostraConfermaEliminaEvento:Boolean= false;
  protected mostraConfermaEliminaEventoCollegati: boolean = false;

  protected showAccompagnatore:boolean= false;
  protected showRiferimento: boolean = false;

  protected segnalazioni:Segnalazione[]=[];
  protected tecnici:Utente[]=[];
  protected operatori: Utente[] = [];

  protected tipiIntervento:TipoIntervento[]=[];

  private collection_eventi:string = environment.firebase.collection_eventi;

  private utente: Utente;
  public utenteIsTecnico: boolean;

  public utentiSpostamento: Utente[];
  isLoadingUtenti: boolean;

  eventoHasAccompagnatori: boolean;

  editEventoCompletato: boolean;
  eventoCompletabile: boolean;

  isLoadingCompetenze: boolean;
  protected competenze: AreaCompetenza[];


  @HostBinding("class.mobile") isMobile: boolean;
  constructor(
      private logger: NGXLogger,
      public dialogRef: DynamicDialogRef,
      public config: DynamicDialogConfig,
      private _formBuilder: FormBuilder,
      private eventiService: EventiService,
      public dialogService: DialogService,
       private messageService: MessageService,
      protected userService:UserService,
      protected areeCompetenzaService:AreeCompetenzaService,
      protected tipiSegnalazioneService:TipiSegnalazioneService,
      private categoriaEventoService:CategorieEventiService,
      private segnalazioniService:SegnalazioniService,
      private utentiService:UtentiService,
      protected tipiInterventoService:TipiInterventoService,
      protected interventiService:InterventiService,
      private confirmationService: ConfirmationService,
      private categorieEventoService: CategorieEventiService,
      public firestore: AngularFirestore,
    ) {
    //  console.log("dialog data ", this.config.data);
      this.utente = this.userService.getUser();
      this.utenteIsTecnico = this.utente?.ruolo.codice == "TECNICO";
      this.detectDevice();
      this.selectedEvento        = this.config.data.evento;
      this.eventoHasAccompagnatori = this.selectedEvento.accompagnatori?.length > 0;
      this.idTecnico           = this.config.data.idTecnico;

      this.eventoCompletabile = [2,4].indexOf(this.selectedEvento.categoria.id) != -1;
      this.editEventoCompletato = this.selectedEvento.stato?.id == 2;
    //  this.logger.info(this.selectedEvento);
      if(this.selectedEvento.categoria.label==='MANUTENZIONE' || this.selectedEvento.categoria.label==='INTERVENTO'){
        this.showRiferimento = true;
      }
      if( this.selectedEvento.categoria.label==='INTERVENTO'){


        const queryIntervento = this.firestore.collection(this.collection_eventi).ref.where('id', "==", this.selectedEvento.id);
        onSnapshot(queryIntervento, (qs) => {
          // this.logger.info(this.selectedEvento.id);
          const eventi: any[] = qs.docs.map((item) => {
            const intervento = item.data() as Evento_Firestore;
            // this.logger.info("RECUPERA LA SEGNALAZIONE > " + intervento.idSegnalazione);
            this.segnalazione = new Segnalazione();
            this.segnalazione.id = intervento.idSegnalazione;
            })
          });
      }



  }

  detectDevice() {
    const isMobile = window.matchMedia("(max-width: 768px)").matches;
    this.isMobile = isMobile;
  }
  ngOnDestroy(): void {

  }

  ngOnInit(): void {

    this.loadCategorieEventi();
    this.loadOperatoriRiferimento();
    this.loadUtentiPerSpostamento();
    this.loadAreeCompetenza();

    //this.loadTipiIntervento();
    // this.loadTecniciDisponibili();
    console.log("evento dialog", this.selectedEvento, this.selectedEvento.inizio, typeof(this.selectedEvento.inizio));
    const datestr = (this.selectedEvento.inizio as unknown as string);
    const dataEvento = new Date(datestr);
    // console.log("rebuilt date: ", dataEvento, typeof(dataEvento), datestr);
    // console.log(this.selectedEvento.utente);

      this.isEventoForIntervento = this.selectedEvento.categoria.id == 1;

    this.modificaEventoForm = this._formBuilder.group({
      operatoreRiferimento:   new FormControl({value: this.selectedEvento.operatoreRiferimento, disabled: this.utenteIsTecnico || this.isEventoForIntervento}),
      categoria:              new FormControl({value: this.selectedEvento.categoria, disabled: true}, Validators.required),
      segnalazione:           new FormControl({value: null, disabled: true}),
      tipoIntervento:         new FormControl({value: null, disabled: true}),
      note:                   [this.selectedEvento.note],
      accompagnatore:         new FormControl({value: null, disabled: true}),
      dataEvento:             new FormControl({value: dataEvento, disabled: this.isEventoForIntervento}),
      tecnico_assegnato:   new FormControl({value: this.selectedEvento.utente.id, disabled: this.isEventoForIntervento}),
      evento_completato:   new FormControl({value: this.editEventoCompletato, disabled: this.isEventoForIntervento}),
      competenza:   new FormControl({value: this.selectedEvento.areaCompetenza, disabled: true}),
    });

    console.log("form", this.modificaEventoForm);

    if (this.utenteIsTecnico) {
      this.modificaEventoForm.get("note").disable();
    }

     if(this.selectedEvento.categoria.id==1){
      this.loadSegnalazioni();
      this.showAccompagnatore = true;
      this.loadTecniciDisponibili();
     /*  this.interventiService.getByID(this.selectedEvento.intervento.id.toString()).subscribe(intervento =>{
        this.logger.info(intervento);
        this.intervento = intervento;

        this.segnalazioniService.getByID(this.segnalazione.id.toString()).subscribe(segnalazioneFromDB=>{
          this.segnalazione = segnalazioneFromDB;
          this.logger.info(segnalazioneFromDB);

          this.modificaEventoForm.get("segnalazione").setValue(segnalazioneFromDB);
          //this.modificaEventoForm.get('segnalazione')?.enable();
          this.loadTipiIntervento();

        });
      }); */
    }else if(this.selectedEvento.categoria.id==2){
      this.showAccompagnatore = true;
      this.loadTecniciDisponibili();
    }
  }

  loadCategorieEventi(){
    this.categoriaEventoService.get().subscribe(categorieFromDb=>{
      this.categorie = categorieFromDb;
    });
    // if(this.selectedEvento.categoria.label !== 'INTERVENTO'){
    //   this.modificaEventoForm.get('categoria')?.enable();
    // }
  }

  loadTipiIntervento(){
    // this.logger.info(this.modificaEventoForm.get("segnalazione").value);
    this.tipiInterventoService.getByLabelAreaCompetenza(this.modificaEventoForm.get("segnalazione").value.tipoSegnalazione.areaCompetenza.label).subscribe(tipiInterventoFromDB =>{
      this.tipiIntervento = tipiInterventoFromDB;
      this.isLoadingTipiIntervento = false;
       this.modificaEventoForm.get("tipoIntervento").setValue(this.intervento.tipo);
      //this.modificaEventoForm.get('tipoIntervento')?.enable();
    });
}

  loadAreeCompetenza () {
    this.isLoadingCompetenze = true;
    this.areeCompetenzaService.get().subscribe((data) => {
      console.log("aree competenza", data);
      this.competenze = data;
      this.isLoadingCompetenze = false;
    });

  }

  loadSegnalazioni(){
    this.isLoadingSegnalazioni = true;
    //this.segnalazioniService.getPianificabili().subscribe(segnalazioniPianificabili =>{
      this.segnalazioniService.get().subscribe(segnalazioniPianificabili =>{

    this.segnalazioni = segnalazioniPianificabili;
      //this.modificaEventoForm.get('segnalazione')?.enable();
      this.isLoadingSegnalazioni = false;
      this.interventiService.getByID(this.selectedEvento.intervento.id.toString()).subscribe(intervento =>{
        // this.logger.info(intervento);
        this.intervento = intervento;

        this.segnalazioniService.getByID(this.segnalazione.id.toString()).subscribe(segnalazioneFromDB=>{
          this.segnalazione = segnalazioneFromDB;
          // this.logger.info(segnalazioneFromDB);

          this.modificaEventoForm.get("segnalazione").setValue(segnalazioneFromDB);
          //this.modificaEventoForm.get('segnalazione')?.enable();
          this.loadTipiIntervento();

        });
      });
    });
  }

  loadUtentiPerSpostamento () {
    this.isLoadingUtenti = true;
     const idaccompagnatori = this.selectedEvento.accompagnatori?.map((item) => {
         return item.id;
       }) ?? [];
    this.utentiService.get().subscribe((data: Utente[]) => {
      this.utentiSpostamento = data.filter((item) => {
        return idaccompagnatori.indexOf(item.id) == -1;
      }).sort((itemA, itemB) => {
        return itemA.nome.localeCompare(itemB.nome);
      });
      this.isLoadingUtenti = false;
    });
  }

  loadTecniciDisponibili(){
    this.isLoadingTecnici = true;
     this.utentiService.getTecnici().subscribe(tecniciFromDB=>{
       const idaccompagnatori = this.selectedEvento.accompagnatori?.map((item) => {
         return item.id;
       }) ?? [];
      // this.tecnici = tecniciFromDB.filter(tecnico => tecnico.id != this.idTecnico);
      this.tecnici = tecniciFromDB.filter((tecnico) => {
        return idaccompagnatori.indexOf(tecnico.id) == -1
      });
      //this.modificaEventoForm.get("accompagnatore").setValue(segnalazioneFromDB);
      this.modificaEventoForm.get('accompagnatore')?.enable();
      this.isLoadingTecnici = false;
      console.log("TECNICI per riassegnazione: ", this.tecnici);
    });
  }

  loadOperatoriRiferimento() {
    this.isLoadingOperatori = true;
    this.utentiService.getOperatori().subscribe((operatori) => {
      this.operatori = [...operatori];
      this.isLoadingOperatori = false;
    });
  }

  onCategoriaEventoSelect(event:any){
     if(this.modificaEventoForm.get("categoria").value.label==='INTERVENTO'){
        this.isEventoForIntervento = true;
        this.showAccompagnatore = true;
        this.loadSegnalazioni();
      }else{
        this.isEventoForIntervento = false;
        if(this.modificaEventoForm.get("categoria").value.label==='MANUTENZIONE'){
          this.showAccompagnatore = true;
        }else{
          this.showAccompagnatore = false;
        }
      }
  }
  onSegnalazioneSelect(event:any){
    this.isLoadingTipiIntervento = true;
    this.loadTipiIntervento();

  }

  elimina(){
    this.mostraConfermaEliminaEvento = false;
    this.eventiService.elimina(this.selectedEvento.id.toString()).subscribe(eliminazione => {
      this.dialogRef.close({
        success: true,
        isElimina:true
      });
    });

}

  eliminaCollegati(){
    this.mostraConfermaEliminaEvento = false;
    this.eventiService.eliminaCollegati(this.selectedEvento.id.toString()).subscribe(eliminazione => {
      this.dialogRef.close({
        success: true,
        isElimina:true
      });
    });

}


  conferma(conferma: boolean) {
    if (!conferma) {
      this.dialogRef.close({ success: false });
    } else {
      let evento:Evento = new Evento();
      evento.id = this.selectedEvento.id;
      let operatoreRiferimento:Utente = new Utente();
      operatoreRiferimento = this.modificaEventoForm.get("operatoreRiferimento").value;
      // this.logger.info("--> ID OPERATORE RIFERIMENTO  --> " + this.modificaEventoForm.get("operatoreRiferimento").value.id);
      evento.operatoreRiferimento   = operatoreRiferimento;
      evento.categoria   = this.modificaEventoForm.get("categoria").value;
      evento.note        = this.modificaEventoForm.get("note").value;
      evento.inizio                = this.modificaEventoForm.get("dataEvento").value;
    evento.fine                  = this.modificaEventoForm.get("dataEvento").value;

      if (this.modificaEventoForm.get("evento_completato").value == true) {
        evento.stato = {id: 2};
      }

      const utenteChange = this.modificaEventoForm.get("tecnico_assegnato").value;
      if (utenteChange != null && utenteChange != this.selectedEvento.utente.id) {
        evento.utente = {id: utenteChange} as Utente;
      };


      this.eventiService.modifica(evento).subscribe(eventoModificato => {
          this.dialogRef.close({ success: true});
      },
      error => {
        // console.error('ERRORE CREAZIONE SEGNALAZIONE' + error);
        this.dialogRef.close({
          success: false
        });
      });
    }



  }


}
